import { Modal, Select, Space } from 'antd'

const FY_OPTIONS = ['FY26', 'FY25', 'FY24', 'FY23', 'FY22']

type CreateJobModalProps = {
  open: boolean
  selectedFy: string | null
  onSelectedFyChange: (fy: string | null) => void
  onCancel: () => void
  onConfirm: () => void
  isLoading: boolean
}

export function CreateJobModal({
  open,
  selectedFy,
  onSelectedFyChange,
  onCancel,
  onConfirm,
  isLoading,
}: CreateJobModalProps) {
  return (
    <Modal
      title="Create new job"
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      confirmLoading={isLoading}
      okText="Create job"
      okButtonProps={{ disabled: !selectedFy }}
    >
      <Space direction="vertical" className="w-full">
        <label className="block text-sm font-medium text-gray-700">Financial year</label>
        <Select<string>
          placeholder="Select financial year"
          className="w-full"
          value={selectedFy}
          onChange={onSelectedFyChange}
          options={FY_OPTIONS.map((fy) => ({ value: fy, label: fy }))}
        />
      </Space>
    </Modal>
  )
}
